import React, { useState, useEffect } from "react";
import { Switch, Route, Link, useLocation } from "react-router-dom";
import Slider from "react-slick";
import Logos from "./../components/Logos";
import ImageGallery from "./../components/ImageGallery";
import Videos from "./../components/Videos";
import OurNews from "./../components/OurNews";
import "./../styles/MediaCenter.scss";
import leftmenuicon from "./../img/left-menu-icon-mobile.png";
import Api from "../common/api";

const MediaCenter = () => {

  const [tabs, setTabs] = useState([
    {
      id: 1,
      name: "Haberlerimiz",
      content: "lorem impsum dolor sit amet",
    }
  ]);
  const lang = localStorage.getItem("lang");
  let size = 2;
  if(lang == "en"){
    size = 3;
  }
  const [Paths, setPaths] = useState(useLocation().pathname.split("/"));
  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[size]
  );

  const [activeNews, setActiveNews] = useState(
    useLocation().pathname.split("/")[size+1]
  );

  const [activeNew, setData] = useState([]);

  const [currentTab, setCurrentTab] = useState([]);
  const [isMobileActive, setIsMobileActive] = useState(true);
  const [banner, setBanner] = useState([]);

  React.useEffect(() => {
    Api.get("/home/getmenu?slug=" + Paths[size-1]).then((res) => {
      setTabs(res.data.items);
      setBanner(res.data.banner);
     if(lang == "en"){
      setCurrentTab(
        res.data.items[res.data.items.findIndex((x) => x.Link_EN == activePath)]
      );
     }else{
      setCurrentTab(
        res.data.items[res.data.items.findIndex((x) => x.Link == activePath)]
      );
     }
      
      setData([]);
    });
    if (activeNews) {
      Api.get("/News/detail?slug=" + activeNews).then((res) => {
        setData(res.data);
      });
    }
  }, [activePath]);

  const adClick = (id) => {
    const tab = tabs.find((tab) => tab.id === id);
    setCurrentTab(tab);
    setIsMobileActive(true);
  };

  let settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 5,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderTitle = () => {
    if (currentTab) {
      if(lang == "en"){
        return <h3>{currentTab.Name_EN}</h3>;
      } else{
        return <h3>{currentTab.Name}</h3>;
      }
      
    }
  };

  function RenderData(tab) {
    if (tab.content.id) {
      if (tab.content.Name === "Logolarımız") {
        return (
          <>
            <h3 className="container-sm header-three">
              {lang == "en" ? tabs.find((tab) => tab.id === currentTab.id).Name_EN : tabs.find((tab) => tab.id === currentTab.id).Name}
            </h3>
            <Logos />
          </>
        );
      }
      if (tab.content.Name === "Fotoğraf Galerisi") {
        return (
          <>
            <ImageGallery />
          </>
        );
      }
      if (tab.content.Name === "Kurumsal Videolar") {
        return (
          <>
            <h3 className="container-sm header-three">
              {lang ==  "en" ? tabs.find((tab) => tab.id === currentTab.id).Name_EN : tabs.find((tab) => tab.id === currentTab.id).Name}
            </h3>
            <Videos />
          </>
        );
      }
      if (tab.content.Name === "Haberlerimiz") {
        return <OurNews new={activeNew ? activeNew : null} />;
      }
    } else {
      return (
        <div className="corporate-content-section">
          {lang == "en" ? (
          <p>
            <br />
            {renderTitle(tab.Name_EN)}
            {tab.content.content ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: tab.content.content.Content_EN,
                }}
              ></div>
            ) : null}
          </p>
          ):(<p>
            <br />
            {renderTitle(tab.Name)}
            {tab.content.content ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: tab.content.content.Content_TR,
                }}
              ></div>
            ) : null}
          </p>
          )}
        </div>
      );
    }
  }

  return (
    <>
      <header
        className="contact-header"
        style={{
          backgroundImage:
            `url("https://sankoenerji.com.tr` + banner + `")`,
        }}
      ></header>
      <div className="slider-deneme career-slider">
        <Slider className="slider-tab" {...settings}>
          {tabs
            ? tabs.map((tab) => {
                return (
                  lang ==  "en" ? (
                  <Link
                    className={currentTab.id === tab.id ? "active" : null}
                    key={tab.id}
                    to={"/en/" + Paths[2] + "/" + tab.Link_EN}
                    onClick={() => adClick(tab.id)}
                  >
                    {tab.Name_EN}
                  </Link>
                  ):(<Link
                    className={currentTab.id === tab.id ? "active" : null}
                    key={tab.id}
                    to={"/" + Paths[1] + "/" + tab.Link}
                    onClick={() => adClick(tab.id)}
                  >
                    {tab.Name}
                  </Link>)
                );
              })
            : null}
        </Slider>
      </div>
      <div
        className={ "mobile-santral-tabs active"}
      >
        {tabs
          ? tabs.map((tab) => {
              return (
                lang == "en" ? (
                <li
                  className={currentTab.id === tab.id ? "active-tab" : null}
                  key={tab.id}
                >
                  <Link
                    className={currentTab.id === tab.id ? "active" : null}
                  
                    to={"/en/" + Paths[size] + "/" + tab.Link_EN}
                    onClick={() => adClick(tab.id)}
                  >
                    {tab.Name_EN}
                  </Link>
                </li>
                ):(
                  <li
                  className={currentTab.id === tab.id ? "active-tab" : null}
                  key={tab.id}
                >
                  <Link
                    className={currentTab.id === tab.id ? "active" : null}
                  
                    to={"/" + Paths[size] + "/" + tab.Link}
                    onClick={() => adClick(tab.id)}
                  >
                    {tab.Name}
                  </Link>
                </li>

                )
              );
            })
          : null}
      </div>
      <button
        onClick={() => setIsMobileActive(!isMobileActive)}
        className={!isMobileActive ? "mobile-toggle" : "mobile-toggle deactive"}
      >
        <img src={leftmenuicon} alt="sada" />
      </button>
      <div className="breadcrumbz container-sm ">
        {lang == "en" ? (
        <ol>
          <li>
            <Link to="/en">
              Homepage <span>&gt;</span>
            </Link>
          </li>
          <li>
            <a href="/media-center/our-news">
              Media Center <span>&gt;</span>
            </a>
          </li>
          <li>
            {tabs.length > 0 || currentTab.id ? (
              <Link to={Paths[size]}>{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>
        ):(
          <ol>
          <li>
            <Link to="/">
              Anasayfa <span>&gt;</span>
            </Link>
          </li>
          <li>
            <a href="/medya-merkezi/haberlerimiz">
              Medya Merkezi <span>&gt;</span>
            </a>
          </li>
          <li>
            {tabs.length > 0 || currentTab.id ? (
              <Link to={Paths[1]}>{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>

        )}
      </div>
      <Route>
        <RenderData content={currentTab} />
      </Route>
    </>
  );
};

export default MediaCenter;
